import React, { createContext, useContext, useReducer } from "react";

interface IPanelState {
  info?: boolean;
  settings?: boolean;
  whois?: {
    x: number;
    y: number;
    surrounding: string[][];
    requestId: string;
  };
}

type PanelActions = {
  [k in keyof Required<IPanelState>]: [k, IPanelState[k]];
}[keyof IPanelState];

const context = createContext<{
  state: IPanelState;
  dispatch: React.ActionDispatch<[PanelActions]>;
}>({} as any);

export const usePanel = () => useContext(context);

const PanelContext = ({ children }: React.PropsWithChildren) => {
  const [state, dispatch] = useReducer<IPanelState, [PanelActions]>(
    (state, [key, value]) => {
      const nextState = { ...state, [key]: value };

      if (value && key === "settings") nextState.whois = undefined;
      if (value && key === "whois") nextState.settings = undefined;

      return nextState;
    },
    {},
  );

  return (
    <context.Provider value={{ state, dispatch }}>{children}</context.Provider>
  );
};

export default React.memo(PanelContext);
